import { useEffect, useState } from "react";
import { Gizmo, gnov } from "flowy-3-core";
import styled from "styled-components";
import { Button as AButton } from "antd";
import axios from "axios";
import config from "../../config";

const Button = styled(AButton)`
  marign: 5px 0;
  width: 100%;
`;

const PdfDownloadButton = ({ gizmo }: { gizmo: Gizmo }) => {
  const downloadPdf = async () => {
    const user = await gizmo.getFoundation()?.getPlatformInterface()?.getUser();
    const credentials: any = user?.credentials;
    const rootGizmoConfig = gizmo.getCallbacks().getInfoCB({
      type: "rootGizmoConfig",
    });
    const register = gizmo.getCallbacks().getInfoCB({
      type: "rootGizmoData",
    });
    const fijiConfigurationFolio = "manifiesto_25";

    try {
      const url = `${config.apiUrl}/main_api/v1/print/pdf`;
      const response = await axios.post(
        url,
        {
          register,
          root_gizmo: rootGizmoConfig,
          template_folio: fijiConfigurationFolio,
        },
        {
          headers: {
            ...credentials,
          },
          responseType: "blob",
        }
      );
      if (response.status === 200) {
        const type = "application/pdf";
        const filename = "manifiesto.pdf";
        const file = new File([response.data], filename || "manifiesto", {
          type,
        });
        // const file = new Blob([response.data], {
        //   type,
        // });

        if (file) {
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(file);
          downloadLink.download = filename;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        }
      }
    } catch (e) {}
  };

  return (
    <div>
      <p>
        <Button type="primary" onClick={downloadPdf}>
          Descargar Manifiesto
        </Button>
      </p>
    </div>
  );
};

export default PdfDownloadButton;
